import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Breadcrumb = ({ componentRoutes }) => {
  const location = useLocation();
  const currentPath = location.pathname.replace('/', '');

  // Filter the breadcrumb data based on the current path
  const breadCrumbs = componentRoutes.filter(route => route.path === currentPath);

  return (
    <div className='breadcrumb mb-[10px]'>
      {breadCrumbs.map((bread, index) => (
        <div
          className="breadcrumb-sec grid gap-y-[5px]"
          key={index}
        >
          {bread.previousPath ? (
            <div className="right-links-sec">
              <ul className="flex gap-x-[5px] items-end leading-none">
                <li>
                  <Link to="/dashboard" aria-label="Dashboard" className='text-blue hover:text-blueHover'>
                    <FontAwesomeIcon icon={faChartLine} className='w-[14px] h-[14px]' />
                  </Link>
                </li>
                <li>
                  <span className='text-blue'>/</span>
                </li>
                <li className='font-semibold text-[12px] leading-none text-blue'>
                  {bread.previousPath}
                </li>
                <li>
                  <span className='text-blue'>/</span>
                </li>
                <li className='font-semibold text-[12px] leading-none text-blue'>
                  {bread.title}
                </li>
              </ul>
            </div>
          ) : null}
          <div className="left-title-sec">
            <h1 className="text-[20px] font-semibold">{bread.title}</h1>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
